module.exports = __webpack_public_path__ + "static/media/character-bg.9c317859.svg";